import { createContext, useContext, useMemo, useState } from "react";

import Service from "../api/service";

const ContinentRegionContext = createContext(null);

export const useContinentRegionContext = () => {
  const v = useContext(ContinentRegionContext);
  if (!v) {
    throw new Error(
      "useContinentRegionContext must be used inside ContinentRegionProvider",
    );
  }
  return v;
};

export const ContinentRegionProvider = ({ children }) => {
  const [regions, setRegions] = useState(null);
  const [regionStats, setRegionsStats] = useState(null);
  const [count, setCount] = useState(0);

  const updateRegionState = async (next) => setRegions(next);

  const fetchRegions = async () => {
    const response = await Service.get("/api/v1/region/continent");
    const payload = response?.data;
    if (payload) {
      setRegions(payload.data);
      setCount(payload.count);
    }
    return response;
  };

  const addRegion = async (payload) =>
    Service.post("/api/v1/admin/region/continent/create", payload);

  const updateRegion = async (id, payload) =>
    Service.put(`/api/v1/admin/region/continent/update/${id}`, payload);

  const deleteRegion = async (id) =>
    Service.delete(`/api/v1/admin/region/continent/delete/${id}`);

  const singleRegionStats = async (id) => {
    const response = await Service.get(`/api/v1/stats/region/${id}`);
    setRegionsStats(response?.data ?? null);
    return response;
  };

  const value = useMemo(
    () => ({
      regions,
      count,
      regionStats,
      setRegions,
      fetchRegions,
      addRegion,
      updateRegion,
      deleteRegion,
      singleRegionStats,
      updateRegionState,
    }),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [regions, count, regionStats],
  );

  return (
    <ContinentRegionContext.Provider value={value}>
      {children}
    </ContinentRegionContext.Provider>
  );
};
